import React from 'react'
import PropTypes from 'prop-types'

const OrderSummary = props => {
  return (
    <div>
      <h4 className="text-dark-blue">Order Summary</h4>
      <table className="table">
        <tbody>
          <tr>
            <td>{props.bookTitle}</td>
            <td>{props.numberOfCodes}</td>
          </tr>
          <tr>
            <td>Price Per Book (USD)</td>
            <td>${(props.bookPrice).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Total Cost</td>
            <td>${props.total}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

OrderSummary.propTypes = {
  bookTitle: PropTypes.string,
  numberOfCodes: PropTypes.number,
  bookPrice: PropTypes.number,
  total: PropTypes.string,
}

export default OrderSummary
